import React from 'react';
import { connect } from 'react-redux';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { SpaceInfo } from '../../state/SpaceInfo';
import { SkipBar } from './SkipBar';

/**
 * When you navigate to a viz page, the first thing you tab to is the SkipBar which shows up
 * above the page header and lets you skip directly to the content (viz or error).
 */

export const errorPageDivId = 'error-content';

export interface SkipBarProviderStateProps {
  readonly spaceInfo: SpaceInfo;
}

export type SkipBarProviderProps = SkipBarProviderStateProps;

export const SkipBarProvider: React.FunctionComponent<SkipBarProviderProps> = (props: SkipBarProviderProps) => {
  if (props.spaceInfo.spaceType === 'view') {
    const iframeSelector = '#viz iframe';
    return <SkipBar iframeSelector={iframeSelector} contentSelector={'#' + errorPageDivId}/>;
  }

  return null;
};

const mapStateToProps: MapStateToProps<SkipBarProviderStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
});

export const ConnectedSkipBarProvider: React.ComponentClass<{}> = connect(mapStateToProps, null)(SkipBarProvider);
